(() => {
  const root = document.querySelector('[data-monolith-advisors]');
  if (!root) return;
  const translations = {
  "de": [
    "Mitmachen & Neuheiten",
    "Ich möchte eine Bewertung schreiben",
    "Deine ehrliche Erfahrung hilft anderen beim Entdecken. Hier kommst du zum vorhandenen Bewertungsbereich dieses Produkts.",
    "Zum Bewertungsbereich",
    "Der Bewertungsbereich ist gerade nicht sichtbar oder noch nicht geladen. Bitte versuche es gleich nochmals oder prüfe den Bereich weiter unten auf der Produktseite.",
    "Ich möchte euch meinen Look zeigen",
    "Wir freuen uns über deinen Look! Sende ein Foto freiwillig per E-Mail oder teile einen Link in einer persönlichen Nachricht.",
    "Das Zusenden ist keine Veröffentlichungsfreigabe. Bevor wir deinen Look veröffentlichen, sprechen wir eine separate Erlaubnis mit dir ab.",
    "E-Mail öffnen & Look anhängen",
    "Nachricht mit Look-Link schreiben",
    "Mein Look für Monolith",
    "Ich möchte euch meinen Look zeigen.",
    "Neuheiten nicht verpassen",
    "Unser Newsletter informiert allgemein über Neuigkeiten und Launches. Ob und wie du ihn abonnierst, wählst du separat im Shop.",
    "Eine Produktbenachrichtigung betrifft dagegen das ausgewählte Produkt beziehungsweise die gewählte Variante. Sie reserviert keinen Artikel.",
    "Zur Neuheiten-Kollektion"
  ],
  "en": [
    "Join in & discover new arrivals",
    "I would like to write a review",
    "Your honest experience helps others discover products. Go to the existing review section for this product.",
    "Go to product reviews",
    "The review section is not visible or has not loaded yet. Please try again shortly or check further down the product page.",
    "I would like to show you my look",
    "We would love to see your look! Voluntarily send a photo by email or share a link in a personal message.",
    "Sending your look does not give permission to publish it. We will ask for separate permission before publishing.",
    "Open email & attach my look",
    "Write a message with my look link",
    "My look for Monolith",
    "I would like to show you my look.",
    "Do not miss new arrivals",
    "Our newsletter shares general news and launches. You choose separately in the shop whether and how to subscribe.",
    "A product notification concerns the selected product or variant instead. It does not reserve an item.",
    "Explore the new arrivals collection"
  ],
  "fr": [
    "Participer & découvrir les nouveautés",
    "Je souhaite écrire un avis",
    "Votre expérience sincère aide les autres à découvrir les produits. Accédez à la rubrique d’avis existante de ce produit.",
    "Voir les avis du produit",
    "La rubrique d’avis est masquée ou pas encore chargée. Réessayez dans un instant ou consultez le bas de la page produit.",
    "Je souhaite vous montrer mon look",
    "Nous aimerions voir votre look ! Envoyez une photo volontairement par e-mail ou partagez un lien dans un message personnel.",
    "L’envoi ne vaut pas autorisation de publication. Nous vous demanderons une permission distincte avant de publier votre look.",
    "Ouvrir un e-mail et joindre mon look",
    "Écrire un message avec le lien du look",
    "Mon look pour Monolith",
    "Je souhaite vous montrer mon look.",
    "Ne pas manquer les nouveautés",
    "Notre newsletter présente les actualités et lancements. Vous choisissez séparément dans la boutique si et comment vous abonner.",
    "Une alerte produit concerne le produit ou la variante sélectionnée. Elle ne réserve aucun article.",
    "Voir la collection des nouveautés"
  ],
  "it": [
    "Partecipa & scopri le novità",
    "Vorrei scrivere una recensione",
    "La tua esperienza sincera aiuta gli altri a scoprire i prodotti. Vai alla sezione recensioni esistente di questo prodotto.",
    "Vai alle recensioni del prodotto",
    "La sezione recensioni non è visibile o non è ancora caricata. Riprova tra poco o controlla più in basso nella pagina prodotto.",
    "Vorrei mostrarvi il mio look",
    "Ci piacerebbe vedere il tuo look! Invia volontariamente una foto via email o condividi un link in un messaggio personale.",
    "L’invio non autorizza la pubblicazione. Prima di pubblicare il tuo look ti chiederemo un permesso separato.",
    "Apri email e allega il mio look",
    "Scrivi un messaggio con il link al look",
    "Il mio look per Monolith",
    "Vorrei mostrarvi il mio look.",
    "Non perdere le novità",
    "La newsletter presenta notizie e lanci generali. Scegli separatamente nel negozio se e come iscriverti.",
    "Un avviso prodotto riguarda invece il prodotto o la variante selezionata. Non riserva alcun articolo.",
    "Scopri la collezione novità"
  ],
  "es": [
    "Participa y descubre novedades",
    "Quiero escribir una reseña",
    "Tu experiencia sincera ayuda a otros a descubrir productos. Accede a la sección de reseñas existente de este producto.",
    "Ir a las reseñas del producto",
    "La sección de reseñas no está visible o aún no se ha cargado. Inténtalo en un momento o revisa más abajo en la página.",
    "Quiero enseñaros mi look",
    "¡Nos encantará ver tu look! Envía una foto voluntariamente por correo o comparte un enlace en un mensaje personal.",
    "El envío no autoriza su publicación. Antes de publicar tu look te pediremos un permiso por separado.",
    "Abrir correo y adjuntar mi look",
    "Escribir mensaje con enlace al look",
    "Mi look para Monolith",
    "Quiero enseñaros mi look.",
    "No perderme las novedades",
    "La newsletter informa sobre noticias y lanzamientos generales. Tú eliges por separado en la tienda si quieres suscribirte y cómo.",
    "Un aviso de producto se refiere al producto o variante seleccionados. No reserva ningún artículo.",
    "Ver la colección de novedades"
  ],
  "pl": [
    "Dołącz i odkryj nowości",
    "Chcę napisać opinię",
    "Twoja szczera opinia pomaga innym odkrywać produkty. Przejdź do istniejącej sekcji opinii o tym produkcie.",
    "Przejdź do opinii o produkcie",
    "Sekcja opinii jest niewidoczna lub jeszcze się nie załadowała. Spróbuj za chwilę lub sprawdź niżej na stronie produktu.",
    "Chcę pokazać Wam mój makijaż",
    "Chętnie zobaczymy Twój makijaż! Dobrowolnie wyślij zdjęcie e-mailem lub udostępnij link w osobistej wiadomości.",
    "Wysłanie nie oznacza zgody na publikację. Przed publikacją poprosimy o osobną zgodę.",
    "Otwórz e-mail i dołącz makijaż",
    "Napisz wiadomość z linkiem do makijażu",
    "Mój makijaż dla Monolith",
    "Chcę pokazać Wam mój makijaż.",
    "Nie przegap nowości",
    "Newsletter informuje ogólnie o nowościach i premierach. Osobno wybierasz w sklepie, czy i jak się zapisać.",
    "Powiadomienie produktowe dotyczy wybranego produktu lub wariantu. Nie rezerwuje produktu.",
    "Zobacz kolekcję nowości"
  ],
  "sv": [
    "Delta & upptäck nyheter",
    "Jag vill skriva en recension",
    "Din ärliga erfarenhet hjälper andra att upptäcka produkter. Gå till produktens befintliga recensionsdel.",
    "Gå till produktrecensioner",
    "Recensionsdelen är dold eller har inte laddats än. Försök snart igen eller titta längre ned på produktsidan.",
    "Jag vill visa er min look",
    "Vi vill gärna se din look! Skicka frivilligt ett foto via e-post eller dela en länk i ett personligt meddelande.",
    "Att skicka bilden ger inte tillstånd att publicera den. Vi ber om ett separat tillstånd innan vi publicerar din look.",
    "Öppna e-post & bifoga min look",
    "Skriv ett meddelande med look-länk",
    "Min look för Monolith",
    "Jag vill visa er min look.",
    "Missa inga nyheter",
    "Nyhetsbrevet berättar allmänt om nyheter och lanseringar. Du väljer separat i butiken om och hur du vill prenumerera.",
    "En produktavisering gäller i stället vald produkt eller variant. Den reserverar ingen vara.",
    "Se kollektionen med nyheter"
  ],
  "fi": [
    "Osallistu & löydä uutuudet",
    "Haluan kirjoittaa arvostelun",
    "Rehellinen kokemuksesi auttaa muita löytämään tuotteita. Siirry tämän tuotteen olemassa olevaan arvosteluosioon.",
    "Siirry tuotearvosteluihin",
    "Arvosteluosio on piilossa tai ei ole vielä latautunut. Yritä pian uudelleen tai katso tuotesivua alempaa.",
    "Haluan näyttää teille meikkini",
    "Haluamme mielellämme nähdä meikkisi! Lähetä kuva vapaaehtoisesti sähköpostilla tai jaa linkki henkilökohtaisessa viestissä.",
    "Lähettäminen ei anna julkaisulupaa. Pyydämme erillisen luvan ennen meikkisi julkaisemista.",
    "Avaa sähköposti ja liitä meikkikuva",
    "Kirjoita viesti meikkilinkillä",
    "Meikkini Monolithille",
    "Haluan näyttää teille meikkini.",
    "Älä ohita uutuuksia",
    "Uutiskirje kertoo yleisistä uutisista ja julkaisuista. Valitset kaupassa erikseen, haluatko tilata sen ja miten.",
    "Tuoteilmoitus koskee valittua tuotetta tai vaihtoehtoa. Se ei varaa tuotetta.",
    "Katso uutuuskokoelma"
  ],
  "nl": [
    "Doe mee & ontdek nieuwigheden",
    "Ik wil een review schrijven",
    "Je eerlijke ervaring helpt anderen producten ontdekken. Ga naar het bestaande reviewgedeelte van dit product.",
    "Naar de productreviews",
    "Het reviewgedeelte is verborgen of nog niet geladen. Probeer het zo nogmaals of kijk verderop op de productpagina.",
    "Ik wil jullie mijn look laten zien",
    "We zien je look graag! Stuur vrijwillig een foto per e-mail of deel een link in een persoonlijk bericht.",
    "Toesturen geeft geen toestemming voor publicatie. We vragen apart toestemming voordat we je look publiceren.",
    "Open e-mail en voeg mijn look toe",
    "Schrijf een bericht met mijn look-link",
    "Mijn look voor Monolith",
    "Ik wil jullie mijn look laten zien.",
    "Mis geen nieuwigheden",
    "De nieuwsbrief deelt algemeen nieuws en lanceringen. Je kiest apart in de winkel of en hoe je je abonneert.",
    "Een productmelding gaat juist over het gekozen product of de variant. Die reserveert geen artikel.",
    "Naar de collectie met nieuwigheden"
  ]
};
  const locale = root.dataset.locale?.split('-')[0];
  const t = translations[locale] || translations.en;
  const q = key => root.querySelector(`[data-advisor-community-${key}]`);
  const labels = {'entry':0,'title':0,'review-entry':1,'reviews-title':1,'reviews-info':2,'reviews-open':3,'look-entry':5,'look-title':5,'look-info':6,'look-permission':7,'look-email':8,'look-message':9,'news-entry':12,'news-title':12,'news-info':13,'news-notify':14,'news-open':15};
  for (const [key,index] of Object.entries(labels)) q(key).textContent = t[index];
  const shopReviewCopy = {
    de: ['Deine ehrliche Erfahrung hilft anderen. Hier öffnest du unsere Shop-Bewertungen bei Judge.me in einem neuen Tab. Ein bestimmtes Produkt kannst du direkt auf seiner Produktseite bewerten.', 'Zu unseren Shop-Bewertungen'],
    en: ['Your honest experience helps others. Open our shop reviews on Judge.me in a new tab. To review a specific product, visit its product page.', 'Open our shop reviews'],
    fr: ['Votre expérience aide les autres. Ouvrez les avis de notre boutique sur Judge.me dans un nouvel onglet. Pour évaluer un produit, rendez-vous sur sa fiche.', 'Voir les avis de la boutique'],
    it: ['La tua esperienza aiuta gli altri. Apri le recensioni del negozio su Judge.me in una nuova scheda. Per recensire un prodotto, visita la sua pagina.', 'Apri le recensioni del negozio'],
    es: ['Tu experiencia ayuda a otras personas. Abre las reseñas de la tienda en Judge.me en una pestaña nueva. Para valorar un producto, visita su página.', 'Ver reseñas de la tienda'],
    pl: ['Twoja opinia pomaga innym. Otwórz opinie o sklepie w Judge.me w nowej karcie. Aby ocenić konkretny produkt, przejdź na jego stronę.', 'Opinie o sklepie'],
    sv: ['Din erfarenhet hjälper andra. Öppna våra butiksomdömen på Judge.me i en ny flik. Besök produktsidan för att recensera en viss produkt.', 'Öppna butiksomdömen'],
    fi: ['Kokemuksesi auttaa muita. Avaa kauppamme arvostelut Judge.me-palvelussa uuteen välilehteen. Voit arvioida tietyn tuotteen sen tuotesivulla.', 'Avaa kaupan arvostelut'],
    nl: ['Jouw ervaring helpt anderen. Open onze winkelbeoordelingen op Judge.me in een nieuw tabblad. Beoordeel een specifiek product op de productpagina.', 'Bekijk winkelbeoordelingen']
  };
  const shopReviews = shopReviewCopy[locale] || shopReviewCopy.en;
  if (!root.dataset.productId) {
    q('reviews-info').textContent = shopReviews[0];
    q('reviews-open').textContent = shopReviews[1];
  }
  const newsletterCopy = {
    de: ['Zum Newsletter', 'Newsletter abmelden', 'Du möchtest keine Newsletter mehr? Öffne einen unserer Newsletter und wähle den Abmeldelink am Ende der E-Mail. Eine Produktbenachrichtigung wird separat verwaltet.'],
    en: ['Go to the newsletter', 'Unsubscribe from the newsletter', 'No longer want newsletters? Open one of our newsletters and use the unsubscribe link at the end of the email. Product notifications are managed separately.'],
    fr: ['Aller à la newsletter', 'Se désabonner de la newsletter', 'Vous ne souhaitez plus recevoir la newsletter ? Ouvrez une de nos newsletters et utilisez le lien de désabonnement en bas de l’e-mail. Les alertes produit sont gérées séparément.'],
    it: ['Vai alla newsletter', 'Annullare l’iscrizione alla newsletter', 'Non vuoi più ricevere la newsletter? Apri una delle nostre newsletter e usa il link di cancellazione in fondo all’e-mail. Le notifiche prodotto sono gestite separatamente.'],
    es: ['Ir al boletín', 'Darse de baja del boletín', '¿Ya no quieres recibir el boletín? Abre uno de nuestros boletines y usa el enlace para darte de baja al final del correo. Las alertas de productos se gestionan por separado.'],
    pl: ['Przejdź do newslettera', 'Wypisz się z newslettera', 'Nie chcesz już otrzymywać newslettera? Otwórz jeden z naszych newsletterów i użyj linku rezygnacji na końcu wiadomości. Powiadomieniami o produktach zarządza się oddzielnie.'],
    sv: ['Till nyhetsbrevet', 'Avsluta prenumerationen', 'Vill du inte längre få nyhetsbrev? Öppna ett av våra nyhetsbrev och använd länken för att avsluta prenumerationen längst ner i mejlet. Produktaviseringar hanteras separat.'],
    fi: ['Siirry uutiskirjeeseen', 'Peru uutiskirjeen tilaus', 'Etkö halua enää uutiskirjeitä? Avaa jokin uutiskirjeistämme ja käytä viestin lopussa olevaa peruutuslinkkiä. Tuoteilmoituksia hallitaan erikseen.'],
    nl: ['Naar de nieuwsbrief', 'Afmelden voor de nieuwsbrief', 'Wil je geen nieuwsbrieven meer? Open een van onze nieuwsbrieven en gebruik de afmeldlink onderaan de e-mail. Productmeldingen worden apart beheerd.']
  };
  const newsletter = newsletterCopy[locale] || newsletterCopy.en;
  ['newsletter-open','unsubscribe-title','unsubscribe-info'].forEach((key,index)=>q(key).textContent=newsletter[index]);
  q('newsletter-open').addEventListener('click',event=>{
    const target = document.querySelector('footer form[is="newsletter-form"]') || document.getElementById('ContactSubscribe-newsletter_3qCrWc');
    if (!target) {
      // Retain the preview when the current page does not have a footer signup.
      const url = new URL(q('newsletter-open').href,location.href);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      q('newsletter-open').href=url.href;
      return;
    }
    event.preventDefault();
    for (let parent=target.parentElement;parent;parent=parent.parentElement) if(parent.tagName==='DETAILS')parent.open=true;
    root.querySelector('dialog').close();
    requestAnimationFrame(()=>{
      target.scrollIntoView({behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches?'auto':'smooth',block:'center'});
      target.querySelector('input[type="email"]')?.focus({preventScroll:true});
    });
  });
  const sections = Array.from(root.querySelectorAll('[data-advisor-community-section]'));
  const openPart = part => {
    if (!['reviews','look','news'].includes(part)) part = 'reviews';
    for (const section of sections) section.open = section.dataset.advisorCommunitySection === part;
    root.querySelector(`[data-advisor-community-section="${part}"] summary`).focus();
  };
  root.querySelectorAll('[data-advisor-community-part]').forEach(button=>button.addEventListener('click',()=>openPart(button.dataset.advisorCommunityPart)));
  root.addEventListener('monolith:community-part',event=>openPart(event.detail?.part));
  root.addEventListener('monolith:view',event=>{if(event.detail.name==='community' && !sections.some(section=>section.open))openPart('reviews');});
  const productTitle = root.querySelector('[data-advisor-success-reference]').dataset.productTitle || '';
  const body = [t[11],productTitle,t[7]].filter(Boolean).join('\r\n\r\n');
  q('look-email').href = 'mailto:info@monolith-shop.eu?subject=' + encodeURIComponent(t[10]) + '&body=' + encodeURIComponent(body);
  q('look-message').addEventListener('click',()=>root.dispatchEvent(new CustomEvent('monolith:consultation',{detail:{topic:(t[5]+' · '+t[7]).slice(0,300),source:q('look-message')}})));
  q('reviews-open').addEventListener('click',event=>{
    const productId = root.dataset.productId;
    if (!productId) return;
    const target = Array.from(document.querySelectorAll('#judgeme_product_reviews, .jdgm-review-widget')).find(widget=>{
      const id = widget.dataset.productId || widget.dataset.id;
      return !id || !productId || String(id) === String(productId);
    });
    if (!target) return;
    event.preventDefault();
    for (let parent=target.parentElement;parent;parent=parent.parentElement) {
      if (parent.tagName==='DETAILS') parent.open=true;
      if (parent.getAttribute('role')==='tabpanel' && parent.id) {
        const tab=Array.from(document.querySelectorAll('[role="tab"][aria-controls]')).find(button=>button.getAttribute('aria-controls')===parent.id);
        if(tab && tab.getAttribute('aria-selected')!=='true')tab.click();
      }
    }
    if (!target.getClientRects().length) {q('reviews-status').textContent=t[4];return;}
    q('reviews-status').textContent='';
    root.querySelector('dialog').close();
    requestAnimationFrame(()=>{
      target.scrollIntoView({behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches?'auto':'smooth',block:'start'});
      const focus = target.querySelector('h2,h3,.jdgm-rev-widg__title') || target;
      focus.tabIndex=-1;focus.focus({preventScroll:true});
    });
  });
})();


